import React from "react";

//Import Components
import Features from "./features";
import WhatWeDo from "./WhatWeDo";

const Section = () => {  
    return (
      <React.Fragment>
        <section className="section overflow-hidden">
          {/* Render Features */}
          <Features />

          {/* what we do in detail */}
          <WhatWeDo />
        </section>
      </React.Fragment>
    );  
}

export default Section;
